/* EP - meniu stalciaus papildymai. 2026-08-29
   Virsuje: logotipas + paieska. Apacioje: telefonas, pastas, soc. tinklai.
   Tema nieko is to neturi, o header-drawer.liquid yra 57KB, todel elementai
   iterpiami cia, o ne perrasant ta faila. */

(function () {
  var PHONE = '+37069999944';
  var PHONE_TEXT = '+370 699 99944';
  var EMAIL = 'info@epardavejas.lt';

  var SEARCH_HTML =
    '<input type="search" name="q" class="ep-menu-search__input" ' +
    'placeholder="Ko ie\u0161kote?" aria-label="Ie\u0161koti prekiu" autocomplete="off">' +
    '<input type="hidden" name="type" value="product">';

  /* Logotipas ir soc. tinklu ikonos klonuojamos is antrastes bei poraste -
     pakeitus juos nustatymuose, stalciuje pasikeis automatiskai. */
  function buildLogo() {
    var source = document.querySelector('.header-logo__image');
    if (!source) return null;
    var link = document.createElement('a');
    link.className = 'ep-menu-logo';
    link.href = '/';
    link.setAttribute('aria-label', 'Epardavejas - pradzia');
    var img = source.cloneNode(true);
    img.removeAttribute('style');
    img.removeAttribute('class');
    link.appendChild(img);
    return link;
  }

  function buildContacts() {
    var box = document.createElement('div');
    box.className = 'ep-menu-contacts';

    var tel = document.createElement('a');
    tel.className = 'ep-menu-contacts__row';
    tel.href = 'tel:' + PHONE;
    tel.textContent = PHONE_TEXT;
    box.appendChild(tel);

    var mail = document.createElement('a');
    mail.className = 'ep-menu-contacts__row';
    mail.href = 'mailto:' + EMAIL;
    mail.textContent = EMAIL;
    box.appendChild(mail);

    var social = document.querySelector('.social-icons__wrapper');
    if (social) {
      var clone = social.cloneNode(true);
      clone.classList.add('ep-menu-contacts__social');
      box.appendChild(clone);
    }

    return box;
  }

  function initDrawer(drawer) {
    /* 1. Virsutine eilute: X + logotipas */
    if (!drawer.querySelector('.ep-menu-head')) {
      var close = drawer.querySelector('.menu-drawer__close-button');
      var logo = buildLogo();
      if (close && close.parentNode && logo) {
        var head = document.createElement('div');
        head.className = 'ep-menu-head';
        close.parentNode.insertBefore(head, close);
        head.appendChild(close);
        head.appendChild(logo);
      }
    }

    /* 2. Paieskos forma pries navigacija */
    if (!drawer.querySelector('.ep-menu-search')) {
      var nav = drawer.querySelector('.menu-drawer__navigation');
      if (nav && nav.parentNode) {
        var form = document.createElement('form');
        form.className = 'ep-menu-search';
        form.action = '/search';
        form.method = 'get';
        form.setAttribute('role', 'search');
        form.innerHTML = SEARCH_HTML;
        nav.parentNode.insertBefore(form, nav);
      }
    }

    /* 3. Kontaktai apacioje - i tuscia temos utility-links dezute */
    if (!drawer.querySelector('.ep-menu-contacts')) {
      var slot = drawer.querySelector('.menu-drawer__utility-links') || drawer;
      slot.appendChild(buildContacts());
    }
  }

  function init() {
    var drawers = document.querySelectorAll('.menu-drawer');
    for (var i = 0; i < drawers.length; i++) initDrawer(drawers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Stalcius gali buti perpiestas (hydration) - pakartojam ji atidarant. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('.menu-drawer-container, .header__icon--menu')) {
      setTimeout(init, 60);
    }
  });
})();
